import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col } from "react-flexbox-grid/lib/index";

import {
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import ShareIcon from "@material-ui/icons/Share";

const handleCopyButtonClick = () => {
  navigator.clipboard.writeText(window.location.href);
};

const SearchFiltersRow = props => {
  const [copyText, setCopyText] = useState("Copy URL");

  return (
    <div>
      <Row>
        <Col xs={9}>
          <Row>
            <Col xs={4}>
              <FormControl fullWidth>
                <InputLabel>Select Range</InputLabel>
                <Select
                  value={props.rangeFilter}
                  onChange={e => props.onRangeChange(e.target.value)}
                >
                  <MenuItem value="1 Days">1 Day</MenuItem>
                  <MenuItem value="1 Weeks">1 Week</MenuItem>
                  <MenuItem value="2 Weeks">2 Weeks</MenuItem>
                  <MenuItem value="1 Months">1 Month</MenuItem>
                  <MenuItem value="2 Months">2 Months</MenuItem>
                  <MenuItem value="3 Months">3 Months</MenuItem>
                  <MenuItem value="4 Months">4 Months</MenuItem>
                  <MenuItem value="5 Months">5 Months</MenuItem>
                  <MenuItem value="6 Months">6 Months</MenuItem>
                  <MenuItem value="7 Months">7 Months</MenuItem>
                  <MenuItem value="8 Months">8 Months</MenuItem>
                  <MenuItem value="9 Months">9 Months</MenuItem>
                  <MenuItem value="10 Months">10 Months</MenuItem>
                  <MenuItem value="11 Months">11 Months</MenuItem>
                  <MenuItem value="1 Years">1 Year</MenuItem>
                  <MenuItem value="2 Years">2 Years</MenuItem>
                  <MenuItem value="3 Years">3 Years</MenuItem>
                  <MenuItem value="4 Years">4 Years</MenuItem>
                  <MenuItem value="5 Years">5 Years</MenuItem>
                  <MenuItem value="100 Years">All history</MenuItem>
                </Select>
              </FormControl>
            </Col>
            <Col xs={4}>
              <FormControl fullWidth>
                <InputLabel>Select Processing Stage</InputLabel>
                <Select
                  value={props.stageFilter}
                  onChange={e => props.onStageChange(e.target.value)}
                >
                  <MenuItem value="Any">Any</MenuItem>
                  <MenuItem value="raw">raw</MenuItem>
                  <MenuItem value="could_not_annotate">
                    could_not_annotate
                  </MenuItem>
                  <MenuItem value="annotated">annotated</MenuItem>
                  <MenuItem value="1_datCnv">1_datCnv</MenuItem>
                  <MenuItem value="2_filter">2_filter</MenuItem>
                  <MenuItem value="3_alignCTD">3_alignCTD</MenuItem>
                  <MenuItem value="4_cellTM">4_cellTM</MenuItem>
                  <MenuItem value="5_loopEdit">5_loopEdit</MenuItem>
                  <MenuItem value="6_derive">6_derive</MenuItem>
                  <MenuItem value="7_deriveTEOS10">7_deriveTEOS10</MenuItem>
                  <MenuItem value="8_binAvg">8_binAvg</MenuItem>
                  <MenuItem value="8_rbr_processed">8_rbr_processed</MenuItem>
                  <MenuItem value="9_qc_auto">9_qc_auto</MenuItem>
                  <MenuItem value="10_qc_pi">10_qc_pi</MenuItem>
                </Select>
              </FormControl>
            </Col>
          </Row>
          <Row>
            <Col xs={5}>
              <TextField
                fullWidth
                type="search"
                value={props.searchFilter}
                label="Filter table"
                onChange={e => props.onFilterChange(e.target.value)}
              />
            </Col>
            <Col xs={5}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.showWirewalker}
                    color="secondary"
                    onChange={e =>
                      props.onShowWirewalkerChange(e.target.checked)
                    }
                  />
                }
                label="Show Wirewalker Casts"
              />
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginTop: 25 }}
            fullWidth
            onClick={props.onRefreshClick}
          >
            Search
            <Search />
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              handleCopyButtonClick();
              setCopyText("Copied URL");
            }}
            style={{ marginTop: 25 }}
            fullWidth
          >
            {copyText}
            <ShareIcon />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

SearchFiltersRow.propTypes = {
  onRefreshClick: PropTypes.func.isRequired,
  searchFilter: PropTypes.string.isRequired,
  showWirewalker: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  onShowWirewalkerChange: PropTypes.func.isRequired,
  rangeFilter: PropTypes.string.isRequired,
  stageFilter: PropTypes.string.isRequired,
  onStageChange: PropTypes.func.isRequired
};

export default SearchFiltersRow;
